import React, {useEffect, useState} from 'react';
import {Icon, iconConstants} from '../Icon';


import * as styleUtils from '../../../utils/styleUtils';

import {I18nMessage} from '../../contexts/I18n';

import onScroll from '../../hooks/onScroll';

import styles from './JumpToTop.scss';


function JumpToTop({}) {

    const [doShow, setDoShow] = useState(false);
    onScroll('.body * * *', isIntersecting => setDoShow(!isIntersecting));

    const onClick = event => {

        event.preventDefault();

        window.scrollTo(0, 0);
    };

    return (
        <div
            className={styleUtils.toClasses(styles.jumpToTop, doShow && styles.shown || null)}
            onClick={onClick}
        >
            <p><I18nMessage id={'global.label.text.backToTop'}/></p>
            <Icon icon={iconConstants.ICON_PAGE_TOP}/>
        </div>
    );
}


JumpToTop.propTypes = {};


export default JumpToTop;
